export type MembershipsTabKey = 'tiers' | 'members' | 'activity' | 'pending';

type TabConfig = {
  key: MembershipsTabKey;
  label: string;
  count?: number | null;
};

type Props = {
  activeTab: MembershipsTabKey;
  onChange: (next: MembershipsTabKey) => void;
  tierCount?: number | null;
  memberCount?: number | null;
  pendingCount?: number | null;
};

const formatCount = (value: number | null | undefined): string | null => {
  if (value == null) return null;
  if (value >= 1000) return `${(value / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  return String(value);
};

const MembershipsTabs = ({ activeTab, onChange, tierCount, memberCount, pendingCount }: Props) => {
  const tabs: TabConfig[] = [
    { key: 'members', label: 'Members', count: memberCount },
    { key: 'tiers', label: 'Tiers', count: tierCount },
    { key: 'pending', label: 'Pending', count: pendingCount },
    { key: 'activity', label: 'Activity' },
  ];

  return (
    <nav className="memberships-page__tabs" role="tablist" aria-label="Memberships sections">
      {tabs.map((tab) => {
        const isActive = tab.key === activeTab;
        const countLabel = formatCount(tab.count);
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`memberships-page__tab${isActive ? ' memberships-page__tab--active' : ''}`}
            onClick={() => onChange(tab.key)}
          >
            {tab.label}
            {countLabel != null ? (
              <span className="memberships-page__tab-count">{countLabel}</span>
            ) : null}
          </button>
        );
      })}
    </nav>
  );
};

export default MembershipsTabs;
